import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/blog/tech-trend-articles/Components/TechTrendsArticles.tsx");
